/* Pluvia — page-wide behaviour.
   Presentation only: no prices, no cart state, no variant logic. Those live
   in the buy-box and cart-drawer sections and read from Shopify, never from
   a number held here.
   Each block is guarded on its own root element so removing a section from
   the theme editor cannot break the rest of the page. */
(function(){
  "use strict";

  /* Set before any other work: the reveal CSS is gated on this class, so if this
     file throws later the page still renders fully. */
  document.documentElement.classList.add("pv-js");
  var $ = function(id){ return document.getElementById(id) };

  /* ── photos: the drawn placeholder is the floor, a real file is the upgrade ──
     Six containers (.shot .thumb .p-img .card-img .d-img .bar-img) hide their
     <img> until it has actually decoded, so a broken file degrades to the drawn
     fallback instead of an empty box. Exposed because the cart drawer renders
     its lines after this runs. */
  function wirePhotos(root){
    [].forEach.call((root || document).querySelectorAll("img"), function(im){
      if (im.dataset.wired) return;
      im.dataset.wired = "1";
      var box = im.parentElement;
      var ok = function(){
        if (im.naturalWidth > 0){ im.classList.add("ok"); if(box) box.classList.add("has"); }
      };
      im.addEventListener("load", ok);
      im.addEventListener("error", function(){
        im.classList.remove("ok"); if(box) box.classList.remove("has");
      });
      if (im.complete) ok();
    });
  }
  window.pluviaWirePhotos = wirePhotos;

  /* shared: two blocks need the scroll position, and "use strict" would keep a
     block-scoped copy invisible to the other.

     Horizon does not scroll the window. From 990px up, base.css gives html and
     body `height:100dvh;overflow:hidden` and makes `.page-wrapper` the scroller,
     so `window.scrollY` is pinned at 0 and `window` never fires a scroll event at
     all — element scroll does not bubble. Everything that reads or moves the
     scroll position has to go through the element that is really scrolling.
     Resolved once per viewport width, because the 990px breakpoint is what
     switches it. */
  var pvScroller = null, pvScrollerW = -1;
  function scroller(){
    if (pvScrollerW === window.innerWidth) return pvScroller;
    pvScrollerW = window.innerWidth;
    pvScroller = null;
    var pw = document.querySelector(".page-wrapper");
    if (pw){
      var oy = getComputedStyle(pw).overflowY;
      if (oy === "auto" || oy === "scroll") pvScroller = pw;
    }
    return pvScroller;
  }
  function scrollTop(){
    var sc = scroller();
    if (sc) return sc.scrollTop;
    return window.scrollY || document.documentElement.scrollTop || document.body.scrollTop || 0;
  }
  function scrollToY(top, behavior){
    (scroller() || window).scrollTo({ top: top, behavior: behavior });
  }
  /* Catch the scroll wherever it happens. Capture on document hears the
     `.page-wrapper` scroll that never reaches `window`. */
  function onScroll(fn){
    window.addEventListener("scroll", fn, { passive:true });
    document.addEventListener("scroll", fn, { passive:true, capture:true });
  }
  wirePhotos(document);

  /* ── menu ── */
  if (document.getElementById("nav-open") && document.getElementById("menu")) {
    /* ── menu ── */
    var mBtn = $("nav-open"), menu = $("menu"), mOpen = false, menuT = null;
    function setMenu(v){
      mOpen = v; mBtn.setAttribute("aria-expanded", v);
      clearTimeout(menuT);
      if (v){
        menu.classList.add("open");
        void menu.offsetWidth;
        menu.classList.add("in");
        menu.querySelector("a").focus();
      } else {
        menu.classList.remove("in");
        menuT = setTimeout(function(){ if (!mOpen) menu.classList.remove("open") }, 240);
      }
    }
    mBtn.addEventListener("click", function(){ setMenu(!mOpen) });
    menu.addEventListener("click", function(e){ if (e.target.closest("a")) setMenu(false) });
  }

  /* ── sticky nav (G-02) ── */
  if (document.querySelector(".hdr")) {
    /* ── G-02 · direction-aware sticky nav ──
       Hides going down, returns going up. Three things keep it from misfiring:
       a movement floor, so a trackpad tremor or iOS rubber-band does not toggle
       it; a reveal threshold, so it never hides while the header is still in its
       own space at the top; and rAF batching, so we read layout once per frame
       instead of once per scroll event. */
    var hdr = document.querySelector(".hdr");
    /* Read the scroll offset from whichever element is actually scrolling.
       A body with overflow-x:hidden silently becomes the scroller and pins
       window.scrollY at 0 — Rovina ships exactly that bug's setup. */
    var lastY = scrollTop(), navTick = false;
    var FLOOR = 5;      /* px of travel before we believe a direction */
    var REVEAL = 120;   /* px before hiding is allowed at all */
    function syncNav(){
      var y = Math.max(0, scrollTop());
      var d = y - lastY;
      if (Math.abs(d) < FLOOR) { navTick = false; return; }
      if (y <= REVEAL)         hdr.dataset.nav = y > 8 ? "stuck" : "";
      else if (d > 0)          hdr.dataset.nav = "hidden";
      else                     hdr.dataset.nav = "stuck";
      lastY = y; navTick = false;
    }
    onScroll(function(){
      if (!navTick){ navTick = true; requestAnimationFrame(syncNav) }
    });
    syncNav();
  }

  /* ── risk-free anchors ── */
  if (document.querySelector('a[href="#buy"], .riskfree, [data-riskfree]') || true) {
    /* ── G-04 · every "Try Risk Free Today" returns to the buy box ── */
    document.addEventListener("click", function(e){
      var jump = e.target.closest("[data-buy-jump]");
      if (!jump) return;
      e.preventDefault();
      var box = document.getElementById("packs") || $("add");
      var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
      /* No buy box on this template — the home page carries the same island.
         Send them to the one product instead of scrolling nowhere. */
      if (!box){
        var to = jump.getAttribute("data-buy-jump");
        if (to) window.location.href = to;
        return;
      }
      scrollToY(box.getBoundingClientRect().top + scrollTop() - 96,
                reduce ? "auto" : "smooth");
      var sel = box.querySelector && (box.querySelector('.pack[aria-checked="true"]') || box.querySelector(".pack"));
      if (sel) setTimeout(function(){ sel.focus({ preventScroll:true }) }, reduce ? 0 : 500);
    });
  }

  /* ── countdown (P-01) ── */
  if (document.getElementById("cd")) {
    /* ── P-01 · seasonal countdown ──
       Two independent parts. The LABEL comes from a date->season map, so it never
       needs editing. The CLOCK runs on a rolling 4-hour cycle derived from the
       wall clock: remaining = CYCLE - (now mod CYCLE). That can never reach zero,
       never shows days, and needs no stored deadline. */
    var SEASONS = [
      /* [month (1-12), day-from, day-to, label] — first match wins */
      [1,  1,  14, "New Year Sale"],   [1, 15, 31, "Winter Sale"],
      [2,  1,  28, "Winter Sale"],     [2, 29, 29, "Winter Sale"],
      [3,  1,  31, "Spring Sale"],     [4,  1, 30, "Spring Sale"],
      [5,  1,  31, "Spring Sale"],     [6,  1, 30, "Summer Sale"],
      [7,  1,  31, "Summer Sale"],     [8,  1, 31, "Summer Sale"],
      [9,  1,  30, "Fall Sale"],       [10, 1, 24, "Fall Sale"],
      [10, 25, 31, "Halloween Sale"],  [11, 1, 20, "November Sale"],
      [11, 21, 30, "Black Friday Sale"],
      [12, 1,  26, "Christmas Sale"],  [12, 27, 31, "New Year Sale"]
    ];
    function seasonLabel(d){
      var m = d.getMonth() + 1, day = d.getDate();
      for (var i = 0; i < SEASONS.length; i++){
        var r = SEASONS[i];
        if (r[0] === m && day >= r[1] && day <= r[2]) return r[3];
      }
      return "Seasonal Sale";
    }
    var CYCLE = 4 * 60 * 60 * 1000;   /* always a few hours left, never days */
    var pad = function(n){ return n < 10 ? "0" + n : "" + n };
    function tickCountdown(){
      var left = CYCLE - (Date.now() % CYCLE);
      var h = Math.floor(left / 3600000);
      var m = Math.floor(left % 3600000 / 60000);
      var sec = Math.floor(left % 60000 / 1000);
      $("cd-h").textContent = pad(h); $("cd-m").textContent = pad(m); $("cd-s").textContent = pad(sec);
    }
    $("cd-season").textContent = seasonLabel(new Date());
    tickCountdown(); setInterval(tickCountdown, 1000);
  }

  /* ── marquee ── */
  if (document.querySelector(".ann-track")) {
    /* ── 2 · marquee that never runs out ──
       Two runs is not enough: when one run is narrower than the viewport the strip
       empties before it wraps, which reads as the banner ending. Clone until the
       track is at least twice the screen, then shift by exactly one run width and
       scale the duration so speed is identical at every size. */
    (function(){
      var track = document.querySelector(".ann-track");
      if (!track) return;
      var runs = track.querySelectorAll(".ann-run");
      if (!runs.length) return;
      var proto = runs[0];
      function build(){
        // back to a single run, then grow to fit this viewport
        var all = track.querySelectorAll(".ann-run");
        for (var i = all.length - 1; i > 0; i--) all[i].remove();
        var one = proto.getBoundingClientRect().width;
        if (!one) return;
        var need = Math.max(3, Math.ceil((window.innerWidth * 2) / one) + 1);
        for (var j = 1; j < need; j++) track.appendChild(proto.cloneNode(true));
        /* Measure the PITCH — run 2's origin minus run 1's — after the clones are
           in, never the lone run's width beforehand. The gap between runs belongs
           to the cycle, and laying out the clones changes the width anyway; using
           the pre-clone width leaves a ~15px jump on every loop. */
        var runsNow = track.querySelectorAll(".ann-run");
        var pitch = runsNow[1].getBoundingClientRect().left -
                    runsNow[0].getBoundingClientRect().left;
        if (!pitch) return;
        track.style.setProperty("--ann-shift", pitch + "px");
        track.style.setProperty("--ann-dur", (pitch / 60) + "s");   /* 60px per second */
      }
      build();
      /* webfonts land after first paint and change every measurement */
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(build);
      var t; window.addEventListener("resize", function(){
        clearTimeout(t); t = setTimeout(build, 180);
      }, { passive:true });
    })();
  }

  /* ── video carousel ── */
  if (document.getElementById("vids-track")) {
    /* ── P-17 · the video carousel ──
       scrollLeft is the single source of truth. The buttons write to it, a swipe
       writes to it, and the dots and the arrow states are read back off it — so
       there is no second copy of "which slide are we on" to drift out of sync.
       Slide width is measured, never assumed: the track is 100% of a wrap whose
       gutter changes at three breakpoints. */
    (function(){
      var track = $("vids-track"), prev = $("vids-prev"), next = $("vids-next"),
          dotBox = $("vids-dots");
      if (!track || !prev || !next || !dotBox) return;
      var slides = track.querySelectorAll(".vids__slide");
      var dots = dotBox.querySelectorAll("button");
      if (slides.length < 2) return;

      function step(){ return track.clientWidth }
      function index(){ return Math.round(track.scrollLeft / Math.max(1, step())) }
      function go(i){
        i = Math.max(0, Math.min(slides.length - 1, i));
        track.scrollTo({ left: i * step(), behavior: "smooth" });
      }
      function paintDots(){
        var i = index();
        for (var d = 0; d < dots.length; d++){
          dots[d].classList.toggle("on", d === i);
          dots[d].setAttribute("aria-current", d === i ? "true" : "false");
        }
        /* max scrollLeft is not (n-1)*step exactly — sub-pixel widths leave a
           fraction behind, and an arrow that never disables is an arrow that
           looks broken at the end. One pixel of slack absorbs it. */
        var max = track.scrollWidth - track.clientWidth;
        prev.disabled = track.scrollLeft <= 1;
        next.disabled = track.scrollLeft >= max - 1;
      }
      prev.addEventListener("click", function(){ go(index() - 1) });
      next.addEventListener("click", function(){ go(index() + 1) });
      for (var d = 0; d < dots.length; d++){
        (function(i){ dots[i].addEventListener("click", function(){ go(i) }) })(d);
      }
      track.addEventListener("keydown", function(e){
        if (e.key === "ArrowRight"){ e.preventDefault(); go(index() + 1) }
        if (e.key === "ArrowLeft"){ e.preventDefault(); go(index() - 1) }
      });
      var raf = false;
      track.addEventListener("scroll", function(){
        if (raf) return;
        raf = true;
        requestAnimationFrame(function(){ raf = false; paintDots() });
      }, { passive:true });
      /* a resize changes the step, so the current slide has to be re-seated or the
         track lands between two of them */
      var rt; window.addEventListener("resize", function(){
        var i = index();
        clearTimeout(rt);
        rt = setTimeout(function(){
          track.scrollTo({ left: i * step(), behavior: "auto" });
          paintDots();
        }, 150);
      }, { passive:true });
      paintDots();
    })();
  }

  /* ── scroll reveal ── */
  if (document.querySelector("[data-rev]")) {
    /* ── 9 · scroll reveal ──
       One observer for every data-rev on the page. Siblings that share a parent
       stagger, so a row of cards arrives as a row instead of all at once. Each
       element is unobserved once it lands: this fires once, it does not replay. */
    (function(){
      var els = document.querySelectorAll("[data-rev]");
      if (!els.length) return;
      if (!("IntersectionObserver" in window) ||
          window.matchMedia("(prefers-reduced-motion: reduce)").matches){
        [].forEach.call(els, function(e){ e.classList.add("seen") });
        return;
      }
      var io = new IntersectionObserver(function(entries){
        entries.forEach(function(e){
          if (!e.isIntersecting) return;
          var sibs = e.target.parentNode.querySelectorAll(":scope > [data-rev]");
          var i = [].indexOf.call(sibs, e.target);
          e.target.style.transitionDelay = Math.min(i, 4) * 80 + "ms";
          e.target.classList.add("seen");
          io.unobserve(e.target);
        });
      }, { rootMargin: "0px 0px -8% 0px", threshold: .12 });
      [].forEach.call(els, function(e){ io.observe(e) });

      /* Safety net. If the observer has revealed nothing at all by now it is not
         working — a throttled tab, a container we did not anticipate, anything.
         Drop the gate instead of adding a class, so visibility stops depending on
         the .seen rule winning the cascade. If some elements HAVE revealed, the
         observer is fine and we leave it alone. */
      setTimeout(function(){
        if (!document.querySelector("[data-rev].seen"))
          document.documentElement.classList.remove("pv-js");
      }, 2500);
    })();
  }

  /* ── timeline rail ── */
  if (document.querySelector(".tl")) {
    /* ── 10 · timeline rail fills with the scroll ──
       The rail is one element, so the fill can track scroll position continuously
       instead of snapping node by node. A fixed line 62% down the viewport is the
       fill head: everything above it is done, everything below is not, and .on
       comes back off if you scroll up — it reports where you are, not how far you
       once got. Geometry is measured, never assumed, because the copy reflows. */
    (function(){
      var wrap = document.querySelector(".tl-wrap");
      if (!wrap) return;
      var nodes = [].slice.call(wrap.querySelectorAll(".tl > li"));
      var dots  = nodes.map(function(li){ return li.querySelector(".tl__dot") });
      if (!nodes.length || dots.indexOf(null) > -1) return;

      var top = 0, span = 1;
      function measure(){
        /* offsets are relative to .tl-wrap: li is the dot's offsetParent, and the
           wrap is the li's, since .tl itself is static. */
        var a = nodes[0].offsetTop + dots[0].offsetTop + dots[0].offsetHeight / 2;
        var b = nodes[nodes.length - 1].offsetTop +
                dots[dots.length - 1].offsetTop + dots[dots.length - 1].offsetHeight / 2;
        top = a; span = Math.max(1, b - a);
        wrap.style.setProperty("--rail-top", top + "px");
        wrap.style.setProperty("--rail-h", span + "px");
      }
      measure();

      if (window.matchMedia("(prefers-reduced-motion: reduce)").matches){
        wrap.style.setProperty("--tl-p", 1);
        nodes.forEach(function(n){ n.classList.add("on") });
        return;
      }

      var queued = false;
      function update(){
        queued = false;
        var r = wrap.getBoundingClientRect();
        var line = window.innerHeight * .62;
        var p = (line - (r.top + top)) / span;
        wrap.style.setProperty("--tl-p", p < 0 ? 0 : p > 1 ? 1 : p);
        for (var i = 0; i < nodes.length; i++){
          var y = r.top + nodes[i].offsetTop + dots[i].offsetTop + dots[i].offsetHeight / 2;
          nodes[i].classList.toggle("on", y <= line + 1);
        }
      }
      function tick(){ if (!queued){ queued = true; requestAnimationFrame(update) } }
      /* capture on document as well: if a later theme puts overflow on the body,
         the body scrolls and window never hears about it. */
      window.addEventListener("scroll", tick, { passive:true });
      document.addEventListener("scroll", tick, { passive:true, capture:true });
      var t; window.addEventListener("resize", function(){
        clearTimeout(t); t = setTimeout(function(){ measure(); update() }, 150);
      }, { passive:true });
      if (document.fonts && document.fonts.ready)
        document.fonts.ready.then(function(){ measure(); update() });
      update();
    })();

    /* Nothing to boot here. Every block in this file self-initialises inside
       its own guard — "use strict" makes their function declarations
       block-scoped, so cross-block calls are not possible by design. */
  }

})();
